
import { getExpenseList, getFuelExpense, delExpense, markAsReviewd, getFuelChartData} from '@/api/expense'
// import moment from 'moment'
import moment from 'moment-timezone'
import { toThousandFilter } from '@/tools/basic-methods'
import store from '@/store/index'


const state = {
  namespaced: true,
  state: {
    allExpenseList: [],
    fuelExpenseList: [],
    allOther: {},
    fuelOther: {},
    refushTime: '',
    fuelChartData: {},
    fuelTableLoading: false,
    fuelChartLoading: false,
    fuelTime: []
  },
  mutations: {
    SET_ALL_EXPENSE_LIST (state, list) {
      state.allExpenseList = list || []
    },
    SET_FUEL_TIME (state, data) {
      state.fuelTime = data || []
    },
    SET_FUEL_CHART_DATA (state, data) {
      if (data.currentSummary) {
        Object.keys(data.currentSummary).forEach(item => {
          if (data.currentSummary[item] !== null && data.currentSummary[item] !== undefined) {
            data.currentSummary[item] = toThousandFilter(data.currentSummary[item])
            data.currentSummary[item] = data.currentSummary[item].toString()
          }
        })
      }
      console.log(data, 'data')
      if (data.lastTime) {
        state.refushTime = moment.tz(data.lastTime, moment.tz.guess()).format('MMM DD, YYYY, HH:mm z')
      }
      if (data.fuelEconomies && !data.fuelEconomies.some(item => item.mpg !== 0)){
        data.fuelEconomies = []
      }
      state.fuelChartData = data
    },
    SET_FUEL_EXPENSE_LIST (state, list) {
      state.fuelExpenseList = list || []
    },
    SET_ALL_OTHER (state, params) {
      state.allOther = params
    },
    SET_FUEL_OTHER(state, params) {
      state.fuelOther = params
    },
    SET_FUEL_TABLE_LOADING(state, params) {
      state.fuelTableLoading = params
    },
    SET_FUEL_CHART_LOADING(state, params) {
      state.fuelChartLoading = params
    }
  },
  actions: {
    setFuelTime({ commit }, params) {
      commit('SET_FUEL_TIME', params)
    },
    getAllList ({ commit }, params) {
      return getExpenseList(params).then(( res ) => {
        console.log(store, 'store.getters')
        let list = res?.data?.pageInfoVO?.data || []
        res.data = Object.assign({}, res.data, res.data.pageInfoVO)
        list.forEach((item) => {
          if(store.getters['user/usersAuthorities']['fleet:accounting:accessCompanyExpenses'] == 'view' && store.getters['user/userId'] !== item.ownerId) {
            item.noPermission = true
            item.commandDisabled = true
          }
          item.date = item.dateTime
          item.amount = '$' + toThousandFilter(item.cost || 0)
        });
        commit('SET_ALL_EXPENSE_LIST', list || [])
        commit('SET_ALL_OTHER', res.data || {})
      })
    },
    getFuelList ({ commit }, params) {
      commit('SET_FUEL_CHART_LOADING', true)
      getFuelChartData(params).then(res => {
        console.log(res, 'res')
        commit('SET_FUEL_CHART_DATA', res.data)
      }).finally(() => {
        commit('SET_FUEL_CHART_LOADING', false)
      })
      commit('SET_FUEL_TABLE_LOADING', true)
      return getFuelExpense(params).then((res) => {
        console.log(res, 'res')
        res.data.data && res.data.data.forEach((item) => {
          if(store.getters['user/usersAuthorities']['fleet:accounting:accessCompanyExpenses'] == 'view' && store.getters['user/userId'] !== item.ownerId) {
            item.noPermission = true
            item.commandDisabled = true
          }
          item.date = item.dateTime
          item.amount = '$' + toThousandFilter(item.amount || 0)
          item.quantity = item.quantity + ' gal'
          item.cost !== null ? item.cost = '$ '+ item.cost : ''
          item.cpg !== null ? item.cpg = '$ '+ item.cpg : ''
          item.pumpOdometer !== null ? item.pumpOdometer = item.pumpOdometer + ' mi' : ''
          item.eldOdometer !== null ? item.eldOdometer = item.eldOdometer + ' mi' : ''
          item.mpg !== null ? item.mpg = item.mpg + ' mi' : ''
        });
        commit('SET_FUEL_EXPENSE_LIST', res.data.data || [])
        commit('SET_FUEL_OTHER', res.data || {})
      }).finally(() => {
        commit('SET_FUEL_TABLE_LOADING', false)
      })
    },
    delExpense(obj, params = []) {
      console.log(obj)
      return delExpense({
        ids: params.toString()
      })
    },
    markAsReviewd(obj, params = {}) {
      console.log(obj)
      return markAsReviewd({
        ids: params.list.toString(),
        type: params.type
      })
    }
  },  
  getters: {
    allExpenseList: state => state.allExpenseList,
    fuelExpenseList: state => state.fuelExpenseList,
    allOther: state => state.allOther,
    fuelOther: state => state.fuelOther,
    refushTime: state => state.refushTime,
    fuelChartData: state => state.fuelChartData,
    fuelTableLoading: state => state.fuelTableLoading,
    fuelChartLoading: state => state.fuelChartLoading,
    fuelTime: state => state.fuelTime,
  }
}

export default state